import React from 'react';

export const pendingWMSReportColumns = (onCellClick, uniqueCategories = []) => {
  const dynamicColumns = [];
  uniqueCategories.forEach((category) => {
    dynamicColumns.push({
      text: category,
      dataField: category,
      formatter: (cell, row) => {
        return (
          <div
            onClick={() =>
              cell?.missing > 0 && onCellClick(cell?.missingVouchers)
            }
            style={{ cursor: cell?.missing > 0 ? 'pointer' : 'default' }}
          >
            <div>{cell?.total || 0}</div>
            <div>{cell?.missing || 0}</div>
          </div>
        );
      },
    });
  });
  return [
    {
      text: 'Warehouse',
      dataField: 'branch',
    },
    {
      text: 'Field',
      dataField: 'field',
      formatter: (cell, row) => {
        return (
          <div>
            <div>Total</div>
            <div>Missing</div>
          </div>
        );
      },
    },
    ...dynamicColumns,
  ];
};

export const pendingInfoTable = () => {
  const columns = [
    {
      text: 'Date',
      dataField: 'date',
      formatter: (cell, row) => new Date(cell).toLocaleDateString(),
    },
    { text: 'Branch', dataField: 'branch' },
    { text: 'From Branch', dataField: 'fromBranch' },
    {
      text: 'Delivery Date',
      dataField: 'deliveryDate',
      formatter: (cell, row) =>
        cell ? new Date(cell).toLocaleDateString() : '',
    },
    {
      text: 'Voucher Date',
      dataField: 'voucherDate',
      formatter: (cell, row) => new Date(cell).toLocaleDateString(),
    },
    {
      text: 'Voucher #',
      dataField: 'voucherNumber',
    },
    {
      text: 'Customer Code',
      dataField: 'customerCode',
    },
    {
      text: 'Customer Name',
      dataField: 'customerName',
    },
    { text: 'Contact', dataField: 'contactNumber' },
    { text: 'Product', dataField: 'product' },
    { text: 'Product Code', dataField: 'productCode' },
    { text: 'Category', dataField: 'productCategory' },
    { text: 'Brand', dataField: 'brand' },
    { text: 'Qty', dataField: 'quantity' },
    { text: 'Van', dataField: 'vanNumber' },
    {
      text: 'Pending Serial Nos',
      dataField: 'pendingSerialNo',
      formatter: (cell, row) => (Array.isArray(cell) ? cell.join(', ') : cell),
    },
    { text: 'Pending Item', dataField: 'pendingItemNo' },
  ];
  return columns;
};
